import { trackEvent } from 'dibs-tracking';

export function fireReadMoreTracking({ tabType }: { tabType: string }): void {
    let gaAction = '';
    switch (tabType) {
        case 'iconic design':
            gaAction = 'about the iconic design read more clicked';
            break;
        case 'seller-maker':
            gaAction = 'about the maker read more clicked';
            break;
        case 'creator':
            gaAction = 'about the creator read more clicked';
            break;
    }
    trackEvent({
        category: 'promo interaction',
        action: gaAction,
        label: 'pdp',
    });
}
